export default __webpack_public_path__ + "static/servis_video_crop-7e80ec1d7e1eadcc395cd03f17b8d3e6.mp4";